"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js");

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchEngine = exports.default = void 0;

var _citeproc = _interopRequireDefault(require("citeproc"));

var _styles = require("./styles.js");

var _locales = require("./locales.js");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var proxied = Symbol.for('proxied');

var getWrapperProxy = function getWrapperProxy(original) {
  var proxy = function proxy(state, entry) {
    if (state.sys.wrapBibliographyEntry) {
      var _state$sys$wrapBiblio = state.sys.wrapBibliographyEntry(this.system_id),
          _state$sys$wrapBiblio2 = _slicedToArray(_state$sys$wrapBiblio, 2),
          prefix = _state$sys$wrapBiblio2[0],
          postfix = _state$sys$wrapBiblio2[1];

      entry = [prefix, entry, postfix].join('');
    }

    return original.call(this, state, entry);
  };

  proxy[proxied] = true;
  return proxy;
};

for (var format in _citeproc.default.Output.Formats) {
  var original = _citeproc.default.Output.Formats[format]['@bibliography/entry'];

  if (!original || original[proxied]) {
    continue;
  }

  _citeproc.default.Output.Formats[format]['@bibliography/entry'] = getWrapperProxy(original);
}

function retrieveLocale(lang) {
  var unnormalised = lang.replace('-', '_');

  if (_locales.locales.has(lang)) {
    return _locales.locales.get(lang);
  } else if (_locales.locales.has(unnormalised)) {
    return _locales.locales.get(unnormalised);
  }
}

var engines = {};

var fetchEngine = function fetchEngine(style, lang, template, retrieveItem, retrieveLocale) {
  var engineHash = "".concat(style, "|").concat(lang);
  var engine;

  if (engines[engineHash] instanceof _citeproc.default.Engine) {
    engine = engines[engineHash];
    engine.sys.retrieveItem = retrieveItem;
    engine.updateItems([]);
  } else {
    engine = engines[engineHash] = new _citeproc.default.Engine({
      retrieveLocale: retrieveLocale,
      retrieveItem: retrieveItem
    }, template, lang, true);
  }

  return engine;
};

exports.fetchEngine = fetchEngine;

var prepareEngine = function prepareEngine(data, templateName, language, format) {
  if (!_citeproc.default.Output.Formats[format] || !_citeproc.default.Output.Formats[format]['@bibliography/entry']) {
    throw new TypeError("Cannot find format '".concat(format, "'"));
  }

  var items = data.reduce(function (store, entry) {
    store[entry.id] = entry;
    return store;
  }, {});

  var template = _styles.templates.get(_styles.templates.has(templateName) ? templateName : 'apa');

  language = _locales.locales.has(language) ? language : 'en-US';

  var callback = function callback(key) {
    if (Object.prototype.hasOwnProperty.call(items, key)) {
      return items[key];
    } else {
      throw new Error("Cannot find entry with id '".concat(key, "'"));
    }
  };

  var engine = fetchEngine(templateName, language, template, callback, retrieveLocale);
  engine.setOutputFormat(format);
  return engine;
};

var _default = prepareEngine;
exports.default = _default;